export const clamp = (value: number, min: number = -Infinity, max: number = Infinity) => Math.min(Math.max(min, value), max);

export const remap = (value: number, inMin: number, inMax: number, outMin: number, outMax: number) =>
	inMin + (outMax - outMin) + (inMax - inMin) * value;